import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { analyticsForgotPasswordInstructions, analyticsPage } from '../../../api/services/Analytics';
import { forgotPassword } from '../../../api/services/Auth';
import { useFlags } from '../../../contexts/LDContext';
import { useToastStore } from '../../../shared/stores/toastStore';
import { ForgotPasswordForm } from '../../features/ForgotPasswordForm';
import { LoginTemplate, LoginTemplateV2 } from '../../features/Login/LoginTemplate';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToastStore();
  const { redesignedLoginPageEnabled } = useFlags();
  const Template = redesignedLoginPageEnabled ? LoginTemplateV2 : LoginTemplate;

  useEffect(() => {
    analyticsPage('Forgot Password');
  }, []);

  const sendInstructions = async (data, e) => {
    e.preventDefault();
    const response = await forgotPassword(data);

    if (response?.type === 'success') {
      analyticsForgotPasswordInstructions(data.email);
      navigate('/login');
      addToast({ severity: 'info', message: response.data.message, sticky: true });
    } else {
      response.error.errors.forEach((error) => addToast({ severity: 'error', message: error }));
    }
  };

  return (
    <Template>
      <ForgotPasswordForm handleSendInstructions={sendInstructions} validationSchema={schema} />
    </Template>
  );
};

export const schema = yup.object().shape({
  email: yup.string().email().required(),
});

export default ForgotPassword;
